import React from 'react'
import { useSelector } from 'react-redux'

import { isClubOneLogged } from '../../../../selectors/selectors'
import ClubOneLoggedIn from './ClubOneLoggedIn/ClubOneLoggedIn'
import ClubOneLogin from './ClubOneLogin/ClubOneLogin'

export default function ClubOne() {
  const clubOneLogged = useSelector(isClubOneLogged)

  return clubOneLogged ? <ClubOneLoggedIn /> : <ClubOneLogin />
}
